import React from "react";
import { Link } from "react-router-dom";
import { css } from "glamor";
import { Row, Col } from "antd";
import { Tunnel } from "react-tunnels";
import { Query } from "react-apollo";

import Button from "@arachnys/styleguide/Button";

import ResearchRequestForm from "../../container/ResearchRequestForm";

import WithAuth from "../../container/WithAuth";
import { withApolloState } from "../../util";

import CommentForm from "./CommentForm";
import FileUploader from "./FileUploader";
import { VIEW_RESEARCH_REQUEST } from "./queries";

const styles = {
    action: css({
        margin: "1rem 0",
        textAlign: "right",
    }),
};

const Submit = () => (
    <div {...styles.action}>
        <Link to="/tickets">
            <Button.Primary htmlType="submit">Done</Button.Primary>
        </Link>
    </div>
);

const ViewPage = props => {
    const { apolloProps, auth } = props;

    const {
        entitySchema,
        relationSchema,
        researchRequestSchema,
        researchRequest,
    } = apolloProps.data;

    return (
        <>
            <Tunnel id="bluebar-title">Request</Tunnel>
            <ResearchRequestForm
                researchRequest={researchRequest}
                schemas={{
                    entitySchema,
                    relationSchema,
                    researchRequestSchema,
                }}
                disable
            />
            <Row gutter={16}>
                <Col span={16}>
                    <FileUploader
                        researchRequest={researchRequest}
                        refetchFiles={apolloProps.refetch}
                        auth={auth}
                    />
                </Col>
                <Col span={8}>
                    <CommentForm
                        ulid={props.match.params.ulid}
                        tags={{ page: "request" }}
                    />
                </Col>
            </Row>
            <Submit />
        </>
    );
};

const ViewPageQuery = props => (
    <Query
        query={VIEW_RESEARCH_REQUEST}
        fetchPolicy="cache-and-network"
        variables={{
            id: btoa("ResearchRequest:" + props.match.params.ulid),
        }}
    >
        {withApolloState(apolloProps => {
            return <ViewPage {...props} apolloProps={apolloProps} />;
        })}
    </Query>
);

export default WithAuth(ViewPageQuery);
